import { useCellDerivedState } from './CellContext'

import { CellContentPreview } from './content/CellContentPreview'
import { CellContentEditor } from './content/CellContentEditor'
import { CellFrame } from './CellFrame'

/**
 * Renders a `cell` of column type `text`.
 * It can either render a text preview or text editor.
 */
export function CellTypeText() {
  const { isEditing, isReadOnly } = useCellDerivedState()

  if (isEditing && !isReadOnly) {
    return (
      <CellFrame>
        <CellContentEditor />
      </CellFrame>
    )
  }

  return (
    <CellFrame>
      <CellContentPreview />
    </CellFrame>
  )
}
